import { Text } from '@chakra-ui/react'

export const DeviceAssociationDescription = () => {
  return (
    <Text color='text.primary' fontSize='14px' lineHeight='20px'>
      <Text as='span' display='block' fontWeight='bold'>
        What is an association?
      </Text>
      Associations are pairings between Cameras and non-Camera devices. These
      pairings allow Cameras to provide video clips that contain footage of
      Incidents that are triggered by the linked non-Camera device.
    </Text>
  )
}
